<template>
  <div class="gameplan">
    <div class='normal_title'>
    <span  style="cursor: pointer;"  @click="showDetail=!showDetail"><i :class="showDetail?'el-icon-caret-bottom':'el-icon-caret-right'" >&ensp;</i>{{channelConfig.themeChannelEnName}}渠道 &ensp; <span class="theme-status">{{ getThemeDetailStatus }}</span></span>
    </div>
    <span v-show="showDetail" class="config-box">
      <div class="operation_btn_box" v-if="isEdit&&!isSubmited">
        <div class="operate_btn operate_btn_white" @click="handleSubmit('save')">保存</div>
        <div class="operate_btn operate_btn_red" @click="handleSubmit('submit')">下发</div>
      </div>
      <!-- <div class="operation_btn_box" v-if="(!isEdit||isSubmited)&&(isOwner||isBU)">
        <div class="operate_btn operate_btn_white" @click="gotoChangeAssign()">修改额度</div>
      </div> -->
      <div class="normal_box" v-if="isConfig">
        <div class="activity_form_box">
          <el-form :inline="true" :model="params" ref="activityNewform" label-position="left" :rules="editRules">
            <el-form-item label="活动形式" label-width="140px" >
              <el-checkbox-group @change="handleActivityFormChange()" v-model="themeStyles">
                <div class="activity_form_item" v-for="styleItem in configInfo.themeStyles" :key="styleItem.themeChannelCode">
                  <el-checkbox @change="changeThemeStyles(styleItem)" class="check-first" :label="styleItem.themeStyleCode">
                    {{styleItem.themeStyleName}}
                  </el-checkbox>
                  <div class="activity_form_second_sel" v-if="styleItem.themeLevels&&styleItem.themeLevels.length>0">
                    <div v-if="styleItem.themeLevels&&styleSelected(styleItem.themeStyleCode)">
                      <el-checkbox class="children_item size_small" @change="changeThemeLevels(levelItem,styleItem)" v-for="levelItem in styleItem.themeLevels" :key="levelItem.themeLevelCode"
                      :label="levelItem.themeLevelCode">
                      {{ levelItem.themeLevelName }}
                      </el-checkbox>
                    </div>
                  </div>
                </div>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="tab_box tab_item_context">
        <div class="tab">
          <el-tabs v-model="active" tab-position="left" :before-leave="beforeLeaveTab" stretch v-if="themeStylesConfig.length>0">
              <el-tab-pane  v-for="styleItem of themeStylesConfig" :key="styleItem.key"  :name="styleItem.key">
                <span slot="label" class="tab-title">
                  <div v-if="styleItem.type!=='03'" class="style-name">{{styleItem.themeStyleName }}</div>
                  <div v-else class="level-name">{{ styleItem.themeLevelName}}</div>
                  <div v-if="styleItem.type!=='02'&&isEdit" class="tab-title-icon">
                    <div v-if="getIcon(styleItem.key)||(themeBasic.orgLevel==='hq'&&(isBU&&!getBUEditstatus(styleItem)))" style="color:green"><i class='el-icon-check'></i></div>
                    <div v-else class="warning-tip" style="color:#fadc6b">!&ensp;</div>
                  </div>
                </span>
                <div v-if="styleItem.type!=='02'">
                  <ConfigureThemeItem v-if="isEdit&&isOwner" :validDetail="validDetail" :themeId="themeId" :ref="`configDetailRef${styleItem.key}`" :itemKey="styleItem.key" :configInfo="styleItem" :themeChannelCode="channelConfig.themeChannelCode"
                    @submitDetail="handleReceiveDetail" />
                  <ConfigureThemeItemInfo v-else-if="isEdit&&!isOwner&&!isSubmited&&(isBU&&getBUEditstatus(styleItem))" ref="nextConfigDetailRef" @submitDetail="handleReceiveDetail" :itemKey="styleItem.key" :configInfo="styleItem"/>
                  <ActivityThemeItemInfo v-else :themeId="themeId" :orgLevel="themeBasic.orgLevel" :isSubmited="isSubmited" :isOwner="isOwner" @submitDetail="handleReceiveDetail" :itemKey="styleItem.key" :configInfo="styleItem" :submitInfo="detailList[styleItem.key]"/>
                </div>
              </el-tab-pane>
          </el-tabs>
        </div>
      </div>

      <div class="normal_box margin-top-10">
        <div class="sku-box">
          <el-row>
            <el-col :span="2" class="sku-title"><span v-if="skuRequired" class="color-red">*</span>活动SKU</el-col>
            <el-col :span="18"  v-if="(isEdit&&isOwner)||editSku">
              <el-tag
                class="sku-tag-item"
                style="margin-top:-6px"
                v-for="tag in skuList"
                :key="tag.skuCode"
                closable @close="handleClose(tag)"
                type="danger">
                {{tag.skuName}}
              </el-tag>
              <i @click="showSelectSkuDialog" class="el-icon-circle-plus-outline sku-add-icon"></i>
              <el-button size="mini" type="danger" v-if="(!isEdit&&isOwner)||editSku" @click="handleSubmitSku">提交</el-button>
            </el-col>
            <el-col :span="22" v-else>
              <div class="sku-item">
                <el-tag
                  class="sku-tag-item"
                  style="margin-top:-6px"
                  v-for="tag in skuList"
                  :key="tag.skuCode"
                  type="info">
                  {{tag.skuName}}
                </el-tag>
                <!-- <div v-for="(item,index) of skuList" :key="item.skuCode">{{ item.skuName + (index!==skuList.length-1?'、':'') }}</div> -->
              </div>
            </el-col>
            <!-- 批量添加 -->
            <el-col :span="4" v-if="(isEdit&&isOwner)||editSku">
              <ConfigureSkuImportVue @on-clear="clearSkuList" @on-uploaded="handleImportSku"></ConfigureSkuImportVue>
             </el-col>
          </el-row>
        </div>
      </div>
    </span>

    <configureSelecteSkuDialog :selectedSku="skuList" :skuScope="skuScope" ref="selectSkuDialog" @handleSelectSku="handleSelectSku" :prNumber="themeBasic.prNumber" />

  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import gameplanApi from "@/api/gameplan";
import ConfigureThemeItem from './configure-theme-item'
import ConfigureThemeItemInfo from './configure-theme-item-info'
import ActivityThemeItemInfo from './activity-theme-item-info'
import configureSelecteSkuDialog from './configure-select-sku-dialog'
import ConfigureSkuImportVue from './configure-theme-sku-import.vue';
export default {
  name: 'configure-theme-style',
  components: {
    ConfigureThemeItem,
    ConfigureThemeItemInfo,
    ActivityThemeItemInfo,
    configureSelecteSkuDialog,
    ConfigureSkuImportVue
  },
  data() {
    return {
      employeeLevel:'',
      showDetail:true,
      active:'',
      allItemConfigList:[],
      configInfo:{},
      itemInfo: {},
      detailList:{},
      params: {
        themeStyles: []
      },
      secondActiveName: '',
      themeStyles: [],
      themeStylesConfig: [],
      themeLevels: [],
      editRules:{
        themeStyles: [{ required: true, message: "请选择活动形式", trigger: "blur" }],
        themeDecorateCodes: [{ required: true, message: "请选择装饰点位", trigger: "blur" }],
      },
      btnType:'',
      themeDetailStatus:'',
      //isAssigned:false,
      isSubmited:false,
      channelSkuDTOList:{
        channelCode:'',
        skuScope:'',
        themeId:''
      },
      skuName:'',
      selectSkuDialog:false,
      skuNameList:[],
      skuList:[],
      editSku:false,
      skuScope:'',
      submitDetail:{},
      submitDetailList:[],
      validDetail:{},
    }
  },
  props: {
    channelConfig:{ type: Object, default: () => {} },
    saveInfo:{ type: Array, default: () => [] },
    themeId:{ type: String, default: ''},
    themeBasic:{ type: Object, default: () => {} },
    isOwner:{ type: Boolean, default: false },
    //historyThemeId:{ type: String, default: '' },
    saveChannelSkuDTOList:{ type: Object, default: () => {} },
    btmpSkuDTOList:{ type: Array, default: () => [] },
    channelAssignVOSLength:{ type: Number, default: 0 }
  },
  watch:{
    active(nval){
      let index = this.themeStylesConfig.findIndex(item=>item.key===nval)
      if(index!==-1){
        if(this.themeStylesConfig[index].type==='02'){
          if((index+1)!==this.themeStylesConfig.length){
            this.active = this.themeStylesConfig[index+1]?.key
          }else {
            this.active=this.themeStylesConfig[0]?.key
          }
        }
      }
    },
    themeStyles(){
      this.$emit('handleStyleChange',this.themeStyles,this.channelConfig.themeChannelCode)
      this.handleChangeValidList()
    },
  },
  created() {
    this.historyThemeId = this.$route.query.historyThemeId
    this.employeeLevel = this.userInfo.employeeLevel
    this.configInfo = Object.assign({},this.channelConfig)
    // type 01:无等级的形式 02：有等级的形式 03：等级
    this.configInfo.themeStyles.forEach(style=>{
      style.type='01'
      style.key = style.themeStyleCode
      this.allItemConfigList.push(style)
      if(style.themeLevels&&style.themeLevels.length>0){
        style.type='02'
        style.selected = []
        style.themeLevels.forEach(level=>{
          level.themeStyleName = style.themeStyleName
          level.themeStyleCode = style.themeStyleCode
          level.type='03'
          level.key = level.themeLevelCode
          this.allItemConfigList.push(level)
        })
      }
    })
    if(this.saveInfo.length>0){
      // 获取已选取的活动形式
      this.saveInfo.forEach(selectedItem=>{
        if(selectedItem.themeDetail.themeLevelCode&&selectedItem.themeDetail.themeStyleCode){
          if(this.themeStyles.indexOf(selectedItem.themeDetail.themeStyleCode)===-1){
            this.themeStyles.push(selectedItem.themeDetail.themeStyleCode)
          }
        }
        this.themeStyles.push(selectedItem.themeDetail.themeLevelCode||selectedItem.themeDetail.themeStyleCode)
      })
      // 展示对应选中的详情页
      this.allItemConfigList.forEach(configItem=>{
        let selectedList = []
        this.saveInfo.forEach(selectedItem=>{
          if(configItem.themeStyleCode===selectedItem.themeDetail.themeStyleCode){
            if(configItem.type==='01'){
              configItem.saveInfo = selectedItem
              this.themeStylesConfig.push(configItem)
            }else if(configItem.type==='02'){
              if(selectedList.indexOf(selectedItem.themeStyleCode)===-1){
                this.themeStylesConfig.push(configItem)
                selectedList.push(selectedItem.themeStyleCode)
              }
              if(selectedItem.themeDetail.themeLevelCode&&selectedItem.themeDetail.themeLevelCode.startsWith(configItem.themeStyleCode+'-')){
                configItem.selected.push(selectedItem.themeDetail.themeLevelCode)
              }
            }else if(configItem.type==='03'){
              if(configItem.themeLevelCode===selectedItem.themeDetail.themeLevelCode){
                configItem.saveInfo = selectedItem
                this.themeStylesConfig.push(configItem)
              }
            }
          }
        })
      })
      this.themeDetailStatus = this.historyThemeId ? '' : this.saveInfo[0].themeDetail.themeDetailStatus
      const subAssignList = this.saveInfo[0].subAssignList || null
    }
    if(Object.keys(this.saveChannelSkuDTOList).length>0){
      this.skuScope = this.saveChannelSkuDTOList.skuScope
      const selectedSku = this.skuScope.split(',')
      this.btmpSkuDTOList.forEach(skuItem=>{
        selectedSku.forEach(selected=>{
          if(selected==skuItem.skuCode){
            this.skuList.push(skuItem)
          }
        })
      })
    }
    this.active = this.themeStylesConfig[0]?.key || ''
    if(this.$route.query.themeChannelCode===this.channelConfig.themeChannelCode) this.showDetail = true
    else this.showDetail = this.getThemeDetailStatus==='待配置'
  },
  computed:{
    ...mapGetters(['userInfo']),
    getConfigTitle(){
      return this.itemInfo.themeChannelEnName+"渠道设置"
    },
    isHQ(){
      return this.employeeLevel>=90
    },
    isBU(){
      return this.employeeLevel>=60&&this.employeeLevel<90
    },
    isRegion(){
      return this.employeeLevel>=45&&this.employeeLevel<60
    },
    getThemeDetailStatus(){
      if(!this.themeDetailStatus||this.themeDetailStatus===100) return '待配置'
      else if(this.themeDetailStatus===400&&!(this.isEdit&&!this.isOwner)) return '执行中'
      else if(this.themeDetailStatus===400&&(this.isEdit&&!this.isOwner)) return '待配置'
      else if(this.themeDetailStatus===500) return '已完成'
      else return ''
    },
    isConfig(){
      if(!this.themeDetailStatus) return true
      else return false
    },
    isEdit(){
      // if(this.isAssigned&&!this.isOwner) return false
      let isEdit = true
      if(this.isBU&&!this.isOwner){
        for(let style of this.themeStylesConfig){
          if(style.type==='01'||style.type==='03'){
            if(style.saveInfo.curAssignList&&style.saveInfo.curAssignList[0]){
              if(style.saveInfo.curAssignList[0].themeStatus<200) return true
              else isEdit = false
            }else {
              isEdit = false
            }
          }
        }
      }else if(this.themeDetailStatus>=400&&this.isOwner) isEdit= false
      else if(this.isSubmited)isEdit = false
      return isEdit
    },
    skuRequired(){
      const selectedList = Object.values(this.detailList)
      let skuRequired = false
      selectedList.forEach(item=>{
        if(item.themeDetail.needSpr===1) skuRequired = true
      })
      return skuRequired
    }
  },
  methods: {
    getConfigInfo(styleItem){
      if(this.isSubmit){
       return this.getSubmitItem(styleItem.key)
      }else return styleItem
    },
    getSubmitItem(key){
      let data = {}
      this.submitDetailList.forEach(item=>{
        if(item.themeDetail.themeLevelCode===key||item.themeDetail.themeStyleCode===key) data = item
      })
      return {saveInfo:data}
    },
    showSelectSkuDialog(){
      this.$refs.selectSkuDialog.show()
      this.$refs.selectSkuDialog.getGameplanThemeThemeSkuList()
    },
    handleSelectSku(skuList){
      // skuList.forEach(clickSku=>{
      //   let index = -1
      //   this.skuList.forEach((selectedSku,i)=>{
      //     if(clickSku.skuCode===selectedSku.skuCode){
      //       index = i
      //     }
      //   })
      //   if(index===-1) this.skuList.push(clickSku)
      //   else this.skuList.splice(index,1)
      // })
      this.skuList = this.checkRepeat([...this.skuList,...skuList] )
      // this.skuList = skuList
      this.skuScope = this.skuList.reduce((pre,item,index)=>{
        return pre+item.skuCode+(index+1===this.skuList.length?"":',')
      },'')
      // this.skuList = skuList
      //this.channelSkuDTOList.skuScope = data.skuScope.join(',')
      //this.skuName = data.skuName.join(',')
    },
    handleEditSku(){
      this.editSku=true
      this.showSelectSkuDialog()
    },
    handleActivityFormChange() {
      this.active = this.themeStylesConfig[0]?.key || ''
    },
    beforeLeaveTab(activeName,oldActiveName){
      if(oldActiveName){
        if (oldActiveName.startsWith(activeName)) {
          return false
        }
      }
    },
    getIcon(itemKey){
      let isValid = true
      const themeDetail = this.detailList[itemKey]?.themeDetail || {}
      const subAssignList = this.detailList[itemKey]?.subAssignList || []
      if(subAssignList.length===0) return isValid = false
      subAssignList.forEach(item=>{
        if(item.assignQty===''){
          isValid = false
        }
      })
      for(let key in themeDetail){
        if(themeDetail[key]===''||themeDetail[key]===null){
          if((themeDetail.needTransitions===0&&key==='perExecDays')||(themeDetail.needTransitions===1&&key==='itemQuantity')){
            return false
          }
          if(themeDetail.needSpr===1&&(key==='pgQtyLimit'||key==='needPerformance')){
            return false
          }
        }
      }
      //this.$set(this.themeStylesConfig[itemKey],isValid,isValid)
      return this.detailList[itemKey].isValid&&((this.skuRequired&&this.skuScope!=='')||!this.skuRequired)
    },
    styleSelected(themeStyleCode){
      return this.themeStyles.indexOf(themeStyleCode) !== -1
    },
    changeThemeStyles(style) {
      const isChecked = this.themeStyles.indexOf(style.themeStyleCode) !== -1
      if(isChecked){
        if(style.type==='02'){
          let list = []
          this.themeStyles.forEach(item=>{
            item.startsWith(style)?list.push(item):''
          })
          if(list.length<2) return
        }
      }else {
        if(style.type==='02'){
          style.selected.forEach(item=>{
            if(this.detailList[item]) this.$delete(this.detailList,item)
          })
          style.selected = []
        }
        else this.$delete(this.detailList,style.themeStyleCode)
      }
      this.getThemeStylesConfig()
    },
    changeThemeLevels(level,style) {
      const isCheckedStyle = this.themeStyles.indexOf(style.themeStyleCode) !== -1
      const isCheckedLevel = this.themeStyles.indexOf(level.themeLevelCode) !== -1
      if(!isCheckedStyle) return
      if(!isCheckedLevel){
        this.$delete(this.detailList,level.themeLevelCode)
        const index = style.selected.indexOf(level.themeLevelCode)
        style.selected.splice(index,1)
      }else {
        style.selected.push(level.themeLevelCode)
      }
      this.getThemeStylesConfig()
    },
    getThemeStylesConfig(){
      this.themeStylesConfig = this.allItemConfigList.filter(item=>{
        let selected = false
        if(item.type==='01'){
          selected = this.themeStyles.indexOf(item.themeStyleCode)!==-1
        }else if(item.type==='02'){
          selected = this.themeStyles.indexOf(item.themeStyleCode)!==-1
          if(item.selected.length===0||!selected) {
            this.themeStyles = this.themeStyles.filter(themeStylesItem=>{
              return !themeStylesItem.startsWith(item.themeStyleCode+'-')
            })
            selected=false
          }
        }else if(item.type==='03'){
          selected = (this.themeStyles.indexOf(item.themeLevelCode)!==-1&&this.themeStyles.indexOf(item.themeStyleCode)!==-1)
        }
        return selected
      })
    },
    handleReceiveDetail(data,itemKey){
      this.$set(this.detailList,itemKey,data)
      this.handleChangeValidList()
      if(this.isEdit&&!this.isOwner){
        let validCount = 0
        this.$refs.nextConfigDetailRef.forEach(item=>{
          const isValid = item.validateAssign()
          if(isValid) validCount++
        })
        if(validCount!==this.$refs.nextConfigDetailRef.length) return
      }
    },
    handleChangeValidList(){
      if(this.isHQ){
        this.validDetail = {}
        for(let key in this.detailList){
          const style = this.detailList[key]
          //if(this.configInfo.key!==key){
            if(style.subAssignList&&style.subAssignList.length>0){
              style.subAssignList.forEach(item=>{
                let isValid = false
                if(item.executorList.length>0) isValid = true
                if(isValid&&this.themeStyles.indexOf(key)!==-1){
                  const data = {
                    code : key,
                    info : style
                  }
                  this.$set(this.validDetail,key,style)
                }
              })
            }
          //}
        }
      }
    },
    submit(type){
      this.btnType = type
      this.itemCount=0
      if(this.$refs.configDetailRef&&this.$refs.configDetailRef.length>0){
        for(let i=0;i<this.$refs.configDetailRef.length;i++){
          this.$refs.configDetailRef[i].submit(type)
        }
      }
      if(this.$refs.configDetailHq&&this.$refs.configDetailHq.length>0){
        for(let i=0;i<this.$refs.configDetailHq.length;i++){
          this.$refs.configDetailHq[i].submit(type)
        }
      }
    },
    async getThemeRegionList(data) {
      //console.log(data);
      const res = await gameplanApi.getThemeRegionList(data);
      if (res.data.resultCode === "0") {
        this.$message.success("提交成功！")
        //this.$router.go(-1)
      }
      this.loading = false
    },
    // async getGameplanThemeSubmit(data) {
    //   //console.log(data);
    //   const res = await gameplanApi.getGameplanThemeSubmit(data);
    //   if (res.data.resultCode === "0") {
    //     this.$message.success("提交成功！")
    //     this.$router.go(-1)
    //   }
    //   this.loading = false
    // },
    handleSubmitSku(){
      this.$confirm(`是否确定提交?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'btn-red',
        type: 'warning'
      })
      .then(async() => {
        const themeBasic = { themeId : this.themeId,prNumber:this.themeBasic.prNumber}
        this.channelSkuDTOList.themeId = this.themeId
        const skuScope = this.skuList.reduce((pre,item,index)=>{
          return pre+item.skuCode+(index+1===this.skuList.length?'':',')
        },'')
        this.channelSkuDTOList.channelCode = this.channelConfig.themeChannelCode
        const channelSkuId = (this.saveChannelSkuDTOList&&this.saveChannelSkuDTOList.channelSkuId) || ''
        const channelSkuDTOList = {
          channelSkuId,
          skuScope,
          themeId : this.themeId,
          channelCode:this.channelConfig.themeChannelCode
        }
        let isRequired = false
        this.saveInfo.forEach(item=>{
          if(item.themeDetail.needSpr===1) isRequired = true
        })
        if(isRequired&&skuScope==='') return this.$message.error("请选择SKU！")
        const res = await gameplanApi.getGameplanThemeUpdateSku(channelSkuDTOList);
        if (res.data.resultCode === "0") {
          this.$message.success("提交成功！")
          this.editSku = false
          // this.isSubmited = true
          //this.$router.go(-1)
        }
      })
      .catch(() => {})
    },
    handleSubmit(type){
      if(this.isEdit&&!this.isOwner){
        let validCount = 0
        this.$refs.nextConfigDetailRef.forEach(item=>{
          const isValid = item.validateAssign()
          if(isValid) validCount++
        })
        if(validCount!==this.$refs.nextConfigDetailRef.length) return
      }
      const selectedList = Object.values(this.detailList)
        // const keyList = Object.keys(this.detailList)
        // keyList.forEach(item=>{
        //   if(!this.detailList[item].isValid){
        //     this.$refs[`configDetailRef${item}`].$ref.editFormRef.validate()
        //   }
        // })
        let detailList = []
        selectedList.forEach(item=>{
          if(Boolean(this.historyThemeId)) {
            let themeDetail = Object.assign({},item.themeDetail)
            this.$delete(themeDetail,'themeDetailId')
            item.themeDetail = themeDetail
          }
          item.subAssignList = item.subAssignList.map(assignItem=>{
            let key
            if(this.isHQ) key ='buCode'
            else if(this.isBU) key='regionCode'
            else if(this.isRegion) key='regionCode'
            key?assignItem[key] = assignItem.orgCode:''
            if(this.historyThemeId) this.$delete(assignItem,'assignId')
            return assignItem
          })
          item.executorList = item.subAssignList.reduce((pre,cur)=>{
            // return cur.executorList?pre.concat(cur.executorList):pre
            return pre.concat(cur.executorList)
          },[])
          detailList.push(item)
        })
        const themeBasic = { themeId : this.themeId,prNumber:this.themeBasic.prNumber}
        this.channelSkuDTOList.themeId = this.themeId
        const skuScope = this.skuList.reduce((pre,item,index)=>{
          return pre+item.skuCode+(index+1===this.skuList.length?'':',')
        },'')
        this.channelSkuDTOList.channelCode = this.channelConfig.themeChannelCode
        const channelSkuId = (this.saveChannelSkuDTOList&&this.saveChannelSkuDTOList.channelSkuId) || ''
        const channelSkuDTOList = {
          skuScope,
          themeId : this.themeId,
          channelCode:this.channelConfig.themeChannelCode
        }
        if(!this.historyThemeId) channelSkuDTOList.channelSkuId=channelSkuId
        const data = {
          themeBasic,
          detailList,
          channelCode:this.channelConfig.themeChannelCode,
          channelSkuDTOList:[channelSkuDTOList]
        }
        let skuRequired = false
        detailList.forEach(item=>{
          if(item.themeDetail.needSpr===1) skuRequired = true
        })
        if(type==='save'){
          // console.log(data);
          this.$confirm(`是否确定保存?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            confirmButtonClass: 'btn-red',
            type: 'warning',
            beforeClose: (action, instance, done) => {
              if (action === 'confirm') {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = '';
                setTimeout(() => {
                  done();
                  setTimeout(() => {
                    instance.confirmButtonLoading = false;
                  }, 300);
                }, 1000);
              } else {
                done();
              }
            }
          })
          .then(() => {
            this.getGameplanThemeSave(data)
          })
          .catch(() => {})
        }else {
          let errorMessage = ''
          if(skuRequired&&skuScope==='')  return this.$message.error("请选择活动SKU")
          let isValid = true
          selectedList.forEach(item=>{
            if(!item.isValid) isValid = false
            if(item.errorMessage&&!errorMessage) errorMessage = item.errorMessage
          })
          if(!isValid) {
            if(errorMessage) this.$message.error(errorMessage)
            else this.$message.error("当前还有未填信息！")
          }else {
            this.$confirm(`是否确定下发?`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              confirmButtonClass: 'btn-red',
              type: 'warning',
              beforeClose: (action, instance, done) => {
                if (action === 'confirm') {
                  instance.confirmButtonLoading = true;
                  instance.confirmButtonText = '';
                  setTimeout(() => {
                    done();
                    setTimeout(() => {
                      instance.confirmButtonLoading = false;
                    }, 300);
                  }, 1000);
                } else {
                  done();
                }
              }
            })
            .then(() => {
              this.getGameplanThemeSubmit(data)
              // this.getGameplanThemeSave(data)
            })
            .catch(() => {})
          }
        }
    },
    async getGameplanThemeSave(data) {
      const res = await gameplanApi.getGameplanThemeSaveThemeInfo(data);
      if (res.data.resultCode === "0") {
        this.$message.success("保存成功！")
        // this.isSubmited = true
        //this.$router.go(-1)
        //this.getGameplanThemeNewDetailList()
      }
      this.loading = false
    },
    async getGameplanThemeSubmit(data) {
      const res = await gameplanApi.getGameplanThemeSubmitThemeDetail(data);
      if (res.data.resultCode === "0") {
        this.$message.success("下发成功！")
        this.themeDetailStatus = 400
        this.isSubmited = true
        this.$emit('submitDetail',this.detailList,this.channelConfig.themeChannelCode)
        //this.getGameplanThemeNewDetailList()
        //this.$router.go(-1)
      }
      this.loading = false
    },
    async getGameplanThemeNewDetailList() {
      const data = {
        themecChannelCode:this.channelConfig.themeChannelCode,
        themeId:this.themeId
      }
      const res = await gameplanApi.getGameplanThemeNewDetailList(data);
      if (res.data.resultCode === "0") {
        const submitDetailList = res.data.resultData.detailList || []
        this.submitDetailList = submitDetailList
        //this.$message.success("保存成功！")
        this.isSubmited = true
        //this.$router.go(-1)
      }
      this.loading = false
    },
    handleClose(tag){
      this.skuList = this.skuList.filter(item=>{
        return item.skuCode!==tag.skuCode
      })
      this.skuScope = this.skuList.reduce((pre,item,index)=>{
        return pre+item.skuCode+(index+1===this.skuList.length?'':',')
      },'')
      this.$refs.selectSkuDialog.handleDataChange()
    },
    async gotoChangeAssign(){
      const params = { themeId:this.themeId}
      const { data } = await gameplanApi.getGameplanThemeChannelAssign(params);
      if (data.resultCode === "0") {
        const channelAssignVOS = data.resultData?.channelAssignVOS || []
        let disabled = false
        if(channelAssignVOS.length>0) {
          channelAssignVOS.forEach(buItem=>{
            if(buItem.themeChannelVOList&&buItem.themeChannelVOList.length>0){
              buItem.themeChannelVOList.forEach(channelItem=>{
                if(channelItem.themeChannelCode===this.channelConfig.themeChannelCode){
                  disabled = true
                }
              })
            }
          })
          if(disabled) this.$message.error("您当前存在配额待审批，请审批完成后再进行编辑额度")
          else this.$router.push({name:'activity-change-assign',query:{themeChannelCode:this.channelConfig.themeChannelCode,themeId:this.themeId}})
        }
        else this.$router.push({name:'activity-change-assign',query:{themeChannelCode:this.channelConfig.themeChannelCode,themeId:this.themeId}})
      }
    },
    getBUEditstatus(styleItem){
      let edit = styleItem.saveInfo&&!styleItem.saveInfo.subAssignList
      if(styleItem.saveInfo.subAssignList&&styleItem.saveInfo.subAssignList[0]){
        edit = styleItem.saveInfo.subAssignList[0].assignStatus<100
      }
      return edit
    },
    // 批量导入成功
    handleImportSku(skuList){
      this.skuList = this.checkRepeat([...this.skuList,...skuList] )
      this.skuScope = this.skuList.reduce((pre,item,index)=>{
        return pre+item.skuCode+(index+1===this.skuList.length?"":',')
      },'')
    },
    // SKU全部删除
    clearSkuList() {
      if (this.skuList.length) {
        this.$confirm('是否确定全部删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.skuList = []
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => { });
      } else {
        this.$message.error('未添加活动SKU')
      }
    },
    // SKU查重
    checkRepeat(arr) {
      for (let i = 0; i < arr.length; i++) {
        for (let j = i + 1; j < arr.length; j++) {
          if (arr[i].skuCode === arr[j].skuCode) {
            arr.splice(j, 1);
            j--;
          }
        }
      }
      return arr
    }
  }
}
</script>
<style lang="scss" scoped>
.sku-box{
  margin:10px 0px 15px 35px;
  font-size: 14px;
}
.sku-tag-item{
  margin:0 10px 8px 0px;
}
.sku-item{
  display: flex;
  flex-wrap: wrap;
}
.sku-edit-icon{
  font-size: 14px;
  color: rgb(29, 165, 255);
  cursor: pointer;
  margin-left: 10px;
  align-items: center;
  vertical-align: middle;
  line-height: 23px;
}
.sku-title{
  font-weight: 600;
}
.sku-add-icon{
  font-size: 20px;
  color: rgb(212, 0, 0);
  cursor: pointer;
  margin:-2px 10px 0 10px;
  align-items: center;
  vertical-align: middle;
}
.sp-el-input .el-input{
  width: 300px;
  margin-right: 10px;
}

.margin-top-10{
  margin-top: 20px;
}
.warning-tip{
  width: 20px;
  text-align: right;
}
::v-deep .tab_item_context .el-tabs .el-tabs__item {
  width: auto !important;
}
.style-name{
  font-size: 15px;
  text-align: left;
  margin:0 10px;
  font-weight: 600;
}

.level-name{
  width: calc(100% - 20px);
  margin-right: 20px;
  text-align: right;
}

.tab-title-icon{
  //width: 30px;
  text-align: center;
  font-size: 20px;
  margin-right: 10px;
  font-weight: 700;
}
.tab-title{
  display: flex;
  justify-content: space-between;
}

::v-deep .tab_item_context .el-tabs .el-tabs__item {
  padding-left: 10px !important;
  // text-align: left !important;
}
.theme-status{
  //font-weight:500;
  color:rgb(230, 0, 0);
  font-size: 14px;
}
.operation_btn_box{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: -30px 0 10px 0;
  .operate_btn{
    text-align: center;
    padding: 5px 20px;
    border-radius: 4px;
    margin: -5px 0  0 10px;
    cursor: pointer;
  }
  .operate_btn_red {
    color: white;
    background-color: rgb(214, 0, 0);
  }
  .operate_btn_white{
    color: rgb(214, 0, 0);
    background-color: white;
    border: 1px solid rgb(214, 0, 0);
  }
}
  .activity_form_second_sel{
    display: flex;
    //margin-left: 40px;
    width:300px;
    justify-content: flex-start;
    .size_small{
      font-size: 14px;
      transform: scale(0.83333);
      transform-origin:1 0;
    }
    .children_item{
      margin-right: 15px;
    }
  }

  ::v-deep .el-menu{
    width: 120px;
  }

  .test{
    display: flex;
  }

  ::v-deep .tab_item_context .el-tabs .el-tabs__item{
    width: 120px;
  }
  ::v-deep .el-tabs--left .el-tabs__header.is-left{
    margin-right: 0;
  }
::v-deep .config-box .el-checkbox__input.is-checked .el-checkbox__inner,
 .config-box .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #409EFF;
  border-color: #409EFF;
}

::v-deep .config-box .el-checkbox__inner:hover,
::v-deep .config-box .el-checkbox__input .el-checkbox__inner:focus {
  border-color: #409EFF !important;
}

::v-deep .config-box .el-checkbox__input.is-focus .el-checkbox__inner,
::v-deep .config-box .el-checkbox__input.is-focus .el-checkbox__inner:hover {
  border-color: #409EFF !important;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #101010;
}

::v-deep .el-checkbox {
  height: 40px;
}

::v-deep .el-form-item {
  .el-form-item__label {
    color: black;
    font-weight: 600;
  }

  .el-form-item__content {
    line-height: 35px !important;
    margin: 3px;
  }
}
::v-deep .el-checkbox__input {
    margin-top: 0px !important;
}
.activity_form_box {
  width: calc(100% - 60px);
  margin-left: 30px;

  .activity_form_item {
    display: flex;
    justify-content: flex-start;
  }
}

.tab_box {
  margin-top: 20px;

  .tab_item_box {
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 8px;

    .tab_item_context {
      height: 100%;
      width: calc(100% - 40px);
      padding: 20px;
    }
  }
}

::v-deep .tab_item_context .el-tabs {
  .el-tabs__nav {
    border: none;
    border-radius: 10px 10px 0px 0px;
    display: flex;
    flex-direction: column;
  }

  .el-tabs__item.is-active {
    color: rgb(0, 119, 255);
  }

  .el-tabs__item {
    min-width: 120px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border: none;
    padding: 0px !important;
    background: #fff;
    margin-right: 3px;
    color: black;
    text-align: center;
  }

  .el-tabs__header {
    border-bottom: none;
    margin-bottom: 0;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 8px;
  }
}
.no_data_tip{
  height: 100px;
  text-align: center;
  vertical-align: middle;
  font-size: 16px;
  margin-top: 80px;
}
.warning{
  margin-left: 140px;
  color: red;
}
.color-red{
  color: red;
  display: inline-block;
  margin-right: 5px;
  vertical-align:middle;
}
.check-first{
  min-width:175px;
}
</style>
